<!--
/**
* @name: List.vue
* @description: 品牌归属国
* @author: 杨波
* @create: 2020/09/16 10:04:37
* @update: 2020/09/16 10:04:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query @search="onSearch">
      <y-query-item>
        <k-input placeholder="请输入国家名称或编码" v-model="para.countryCodeOrName" clearable></k-input>
      </y-query-item>
    </y-query>
    <k-table :data="countryList" height="calc(100vh - 95px)" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
    <k-popup bind="v-if" okText="保存" title="品牌归属国编辑" :show.sync="isPopupShow" @after-ok="onSave">
      <y-form titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-form-item title="国家名称:" align="top" required>
          <k-input v-model="editPara.countryName" block :class="css.inputW" disabled></k-input>
        </y-form-item>
        <y-form-item title="国家国旗:" align="top">
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploaded" v-if="countryFlag.length < 1"></y-upload-file>
            <y-image @delete="onDelete" v-dragging="{ list: countryFlag, item: img, group: 'image' }" v-for="(img, index) in countryFlag" :key="index" :index="index" :src="img"></y-image>
          </div>
          <div class="mt-1">（只能上传1张，每张大小不超过 3M，建议尺寸750*750 px）</div>
        </y-form-item>
        <y-form-item title="国家描述:" align="top">
          <k-input tag="textarea" v-model="editPara.countryDesc" block placeholder="请输入描述..." :class="css.textarea"></k-input>
        </y-form-item>
      </y-form>
    </k-popup>
  </y-view>
</template>

<script>
import { NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_LIST, NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS, NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_SAVE_OR_UPDATE } from "@/assets/modules/apiList";
const initPara = () => ({
  countryCodeOrName: "",
});
const initEditPara = () => ({
  countryCode: "",
  countryName: "",
  countryFlag: "",
  countryDesc: "",
  id: "",
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      countryList: [],
      para: initPara(),
      editPara: initEditPara(),
      isPopupShow: false,
      countryFlag: [],
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "国家名称",
          field: "countryName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "国家编码",
          field: "countryCode",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "国旗",
          field: "countryFlag",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            if (row.countryFlag) {
              return (
                <div class={this.css.box}>
                  <img class={this.css.img} src={row.countryFlag} />
                </div>
              );
            } else {
              return <div class={this.css.box}></div>;
            }
          },
        },
        {
          name: "国家描述",
          field: "countryDesc",
          style: {
            width: 250,
            textAlign: "center",
          },
        },
        {
          name: "状态",
          style: {
            width: 40,
            textAlign: "center",
          },
          customRender: (row) => {
            return (
              <div>
                <span class={row.status ? this.css.enabled : this.css.disabled}></span>
                <span>{row.status ? "启用" : "停用"}</span>
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 40,
            textAlign: "center",
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            return <div>{editButton}</div>;
          },
        },
      ];
    },
    onUploaded(data) {
      this.countryFlag = [];
      this.countryFlag.push(data.data[0].url);
    },
    onSearch() {
      this.getCountryList();
    },
    onDelete(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.countryFlag.splice(obj.index, 1);
        },
      });
    },
    getCountryList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_LIST,
        para,
      }).then((res) => {
        this.countryList = res;
      });
    },
    onEdit(row) {
      this.editPara = JSON.parse(JSON.stringify(row));
      if (this.editPara.countryFlag) {
        this.countryFlag = [this.editPara.countryFlag];
      }
      this.isPopupShow = true;
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      const { tip } = this.$root;
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.countryFlag = this.countryFlag && this.countryFlag.length > 0 ? this.countryFlag.join(",") : "";
      this.isSaving = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_BRAND_COUNTRY_SAVE_OR_UPDATE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.getCountryList();
          this.isPopupShow = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getCountryList();
  },
};
</script>

<style lang="postcss" module="css">
.enabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #52c41a;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.disabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ff4d4f;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.inputW {
  width: 300px !important;
}
.textarea {
  width: 400px !important;
  height: 200px;
  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}
.box {
  padding: 10px 0;
  & > .img {
    width: 70px;
    height: 70px;
  }
}
</style>
